import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g fill="#3E414A" fillRule="nonzero">
          <path d="M22.228 10.953h-8.456a2.819 2.819 0 0 0-2.819 2.819v8.456a2.819 2.819 0 0 0 2.82 2.818h8.455a2.819 2.819 0 0 0 2.819-2.818v-8.456a2.819 2.819 0 0 0-2.82-2.819zm-1.41 2.114h2.115v2.114h-2.114v-2.114zM18 15.181a2.819 2.819 0 1 1 0 5.638 2.819 2.819 0 0 1 0-5.638zm5.637 7.047a1.41 1.41 0 0 1-1.41 1.41h-8.455a1.41 1.41 0 0 1-1.41-1.41v-4.933h1.48a4.228 4.228 0 1 0 8.315 0h1.48v4.933z" />
          <path d="M18 35.526C8.32 35.526.474 27.68.474 18S8.32.474 18 .474 35.526 8.32 35.526 18 27.68 35.526 18 35.526zm0-.947c9.156 0 16.579-7.423 16.579-16.579S27.156 1.421 18 1.421 1.421 8.844 1.421 18 8.844 34.579 18 34.579z" />
        </g>
      </svg>
    )
  }
}

export default SvgFile
